import { NavLink, Link } from "react-router-dom";
import { SignOut } from "@phosphor-icons/react";
import { CLIENT_NAV, STAFF_NAV } from "../../lib/nav";
import { useAuth } from "../../context/AuthContext";

export function SidebarContent({ onNavigate }) {
  const { user, logout } = useAuth();
  const isStaff = user?.role && user.role !== "client";
  const items = isStaff ? STAFF_NAV : CLIENT_NAV;
  const displayName = user?.name || user?.email || "Guest";

  return (
    <div className="flex h-full flex-col bg-sidebar">
      <div className="px-6 py-6 border-b border-border">
        <p className="font-heading text-3xl tracking-[0.16em] text-primary leading-none">
          GLEDSWOOD
        </p>
        <div className="mt-2 flex items-center gap-2 text-[9px] tracking-[0.2em] uppercase text-muted-foreground">
          <span className="h-px flex-1 bg-border" />
          HOMESTEAD + WINERY
          <span className="h-px flex-1 bg-border" />
        </div>
        <p className="eyebrow mt-3 text-secondary">
          Event planning · {isStaff ? "Operations" : "Client portal"}
        </p>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-0.5">
        {items.map((item, i) =>
          item.section ? (
            <p
              key={`s-${i}`}
              className="eyebrow px-3 pt-5 pb-2 text-muted-foreground/70"
            >
              {item.section}
            </p>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={onNavigate}
              data-testid={item.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 rounded-r-lg border-l-2 px-3 py-2 text-sm transition-colors duration-200 ${
                  isActive
                    ? "border-secondary bg-muted/80 text-primary font-semibold"
                    : "border-transparent text-muted-foreground hover:bg-muted/60 hover:text-primary"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon
                    size={18}
                    weight={isActive ? "duotone" : "regular"}
                  />
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          ),
        )}
      </nav>

      <div className="border-t border-border p-4">
        <div className="flex items-center gap-3 mb-2 px-1">
          <div className="h-9 w-9 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-heading text-lg shrink-0">
            {displayName.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-primary truncate">
              {displayName}
            </p>
            <p className="text-xs text-muted-foreground truncate">
              {user?.email}
            </p>
          </div>
        </div>
        <Link
          to="/privacy"
          onClick={onNavigate}
          data-testid="sidebar-privacy-link"
          className="block px-3 py-1.5 text-xs text-muted-foreground hover:text-primary transition-colors duration-200"
        >
          Privacy Policy
        </Link>
        <button
          data-testid="sidebar-logout-btn"
          onClick={() => {
            logout();
            onNavigate?.();
          }}
          className="w-full flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-muted-foreground hover:bg-muted/60 hover:text-primary transition-colors duration-200"
        >
          <SignOut size={18} /> Sign out
        </button>
      </div>
    </div>
  );
}
